/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Akhilesh's Portfolio",
  description:
    "Engineering Excellence, One Pixel at a Time",
  og: {
    title: "Akhilesh Nevatia Portfolio",
    type: "website",
    url: "",
  },
};

//Home Page
const greeting = {
  title: "Akhilesh Nevatia ",
  nickname: "akhilnev",
  subTitle:
    "Junior, Software & Math Major, Crafting Solutions, Loving Innovation",
  resumeLink:
    "https://drive.google.com/file/d/1wzzSQNuR-mMzm-5fBzaaPp_bp1e5no71/view?usp=share_link",
  githubProfile: "https://github.com/akhilnev",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/akhilnev",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/akhilnev/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:akhilesh.nevatia@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  }
];

const skills = {
  data: [

    {
      title: "Android Backend Development",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Hosting and maintaining websites on virtual machine instances along with integration of databases",
        "⚡ Backend development with focus on improving user interaction and deployment efficiency",
        "⚡ Working on learning how to deploy Andoid app to the Cloud using AWS, Kubenetes, and Docker"
      ],
      softwareSkills: [
       
        // ... (other cloud platform skills)
        

        // ... (other database and containerization skills)
        {
          skillName: "Java",
          fontAwesomeClassname: "logos:java",
          style: {
            color: "#007396",
          },
        },
        {
          skillName: "Spring",
          fontAwesomeClassname: "simple-icons:spring",
          style: {
            color: "#6DB33F",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FF6C37",
          },
          
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        }
        // ... (other relevant backend development tools)
      ],
    },
    {
      title: "Machine Learning and Neural Networks",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Actively engaging in mastering Machine Learning techniques through on-campus research.",
        "⚡ Enrolled in Andrew Ng's Stanford Machine Learning course.",
        "Project: ",    
        "⚡ Developing and enhancing a Stock Prediction Software.",
        "⚡ Achieved a remarkable CV error of 0.00051.",
        "⚡ Achieved matching training loss errors, showcasing a commitment to building accurate predictive models for stock values."
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Deeplearning",
          imageSrc: "deeplearning_ai_logo.png",
        },
      ],
    },
   
    
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive website front end using React",
        "⚡ Experience in managing databases for applications, particularly with MongoDB.",
        "Experience in integrating features like Registration, Cart, Payment, and Delivery functionalities into web applications."
      ],
      softwareSkills: [


        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
     
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
    
      ],
    },
    
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/aahanev/",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Iowa State University",
      subtitle: "Bachelor of Science in Software Engineering, Minor in Mathematics",
      logo_path: "Iowa_state_logo.jpeg",
      alt_name: "Iowa State",
      duration: "2021 - Present, Expected Grad: December 2024 (Junior Year, Classification: Senior) ",
      descriptions: [
        "⚡ Consistently maintained Dean’s List status across multiple semesters, reflecting ongoing academic excellence and ranking in the top 2% of the college class.",
        "⚡ Major GPA of 4.00 and a Cumulative GPA of 3.94.",
        "⚡ Secured a top 3 position in ICPC Regionals 2022, and excelled in Pre-Regional and Qualified Regional Mathematics Olympiad, Founding Member of The Autonomous Robotics Club, and Member of the Iowa State University Programming Club.",
        "⚡ Attained top percentile rank in the IIT-JEE MAINS exam, placing in the top 1% among 1.5 million students, and earned the prestigious India National Gold Medal in Mental Math (ABACUS) among 10,000+ participants, showcasing exceptional academic achievements.",
        "⚡ Engaged in advanced coursework in Machine Learning through the DeepLearning.AI program sponsored by Stanford",
        "⚡ Worked with NASA Professional in the L'Space NPWEE Program"
    ],
    
      website_link: "https://www.google.com/aclk?sa=l&ai=DChcSEwi4x53Yn5-CAxUZ_MgKHWsUOwEYABAAGgJxdQ&ae=2&gclid=EAIaIQobChMIuMed2J-fggMVGfzICh1rFDsBEAAYASAAEgJa_vD_BwE&sig=AOD64_0aOmV-Nyp8US2pDGytEy5SAfg5Eg&q&adurl&ved=2ahUKEwjmtZLYn5-CAxX2lokEHahzB5gQ0Qx6BAgJEAE",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning ( Currently Ongoing )",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    
    {
      title: "Goldman Sachs Engineering Virtual Program",
      subtitle: "Goldman Sachs",
      logo_path: "Goldman_sachs.jpeg",
      certificate_link:
        "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/Goldman%20Sachs/NPdeQ43o8P9HJmJzg_Goldman%20Sachs_MDF3gRzaQ3CpCwo9w_1655392433179_completion_certificate.pdf",
      alt_name: "GCP",
      color_code: "#4285F499",
    },

    {
      title: "JP Morghan Chase & Co. Software Engineering Virtual Program",
      subtitle: "JP Morgan Chase & Co.",
      logo_path: "jpm.png",
      certificate_link:
        "https://forage-uploads-prod.s3.amazonaws.com/completion-certificates/J.P.%20Morgan/Wb4yEmHvZrC2qxiyX_JPMorgan%20Chase%20&%20Co._MDF3gRzaQ3CpCwo9w_1687152456253_completion_certificate.pdf",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Research, Internship and Volunteership",
  description:
    "I have taught OOP and multivariable Calculus on campus, am currently involved with research hoping to get a paper co-published soon, and have interned with Collins Aerospace as a Software Engineering Intern last Summer ",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Research and internships",
      work: true,
      experiences: [
        {
          title: "Research Assistant - Honors Department",
          company: "Iowa State University - Computer Science Department",
          company_url: "",
          logo_path: "research_assistant.jpeg",
          duration: "June 2022 - Present",
          location: "Ames, Iowa",
          description:
            "• Developing and rigorously testing a machine learning software using Python to improve the processing and analysis of hidden data and messages within images and files",
          color: "#0879bf",
        },
        {
          title: "Software Engineering Intern",
          company: "Collins Aerospace - RTX",
          company_url: "",
          logo_path: "collins_sybmol.jpeg",
          duration: "May 2023 - June 2023",
          location: "Ames, Iowa",
          description:
            "• Final Project: Analyzed and submitted a report to rectify a software issue that incorrectly detected a “no – runway” scenario and delivered inaccurate error messages on an aircraft’s flight management system using root-cause analysis, Collabrated with Senior Engineers and proposed solutions to rectify error messages",
          color: "#9b1578",
        },
        {
          title: " Mathematics and Computer Science Tutor",
          company: "Iowa State University",
          company_url: "",
          logo_path: "Iowa_state_logo.jpeg",
          duration: "January 2022 - December 2022",
          location: "Ames, Iowa",
          description:
            "• Tutored College Students in Multivariable Calculus (MATH 265) and Object-Oriented Programming (COMS 227), • Led multiple batches in groups of 5 and helped increase grade average by 20%, according to yearly college reports",
          color: "#9b1578",
        },
      ],
    },
   
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Mathematics Tutor",
          company: "AngelXpress",
          company_url: "",
          logo_path: "angelXpress.jpeg",
          duration: "",
          location: "Mumbai, India",
          description:
            "• Taught Mathematics to financially constrained high school juniors, • Covered topics: Differential and Integral Calculus, Geometry, Matrix, and Determinants, • Conducted online classes during the peak of the COVID-19 pandemic",
          color: "#4285F4",
        },
        {
          title: "Summer Camp Instructor",
          company: "Scribbles Educational Trust",
          company_url: "https://scribblespreschool.in",
          logo_path: "scribbles_logo.png",
          duration: "",
          location: "Bangalore, India",
          description:
            "• Organized annual summer camps to cultivate early interest and build a strong math foundation, • Managed multiple batches of 5-15 students during summer camps, • Achieved a remarkable 75% retention rate of students over three consecutive summers",
          color: "#D83B01",
        },

      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. I hope you enjoy going through them!",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I am working on getting a paper published with my research Professor at Iowa State University.",
  avatar_image_path: "",
};

const publications = {
  data: [

  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "Akhilesh_Profile.jpg",
    description:
      "I am super-interested in Software Engineering and its diverse applications across Fintech, technology, and other industries. My background encompasses Backend Android Development, Avionics, and Flight Management Systems. Currently, I'm delving into areas such as Machine Learning, IOS Development, and DevOps. I am always eager to explore new opportunities and engage in discussions. Feel free to reach out – I'd love to connect! ",
  },
  blogSection: {
    title: "",
    subtitle:
      "",
    link: "",
    avatar_image_path: "",
  },
  addressSection: {
    title: "Address",
    subtitle:
      "246 N Hyland Ave, Ames, IA 50014",
    locality: "",
    country: "US",
    region: "Ames",
    postalCode: "50014",
    streetAddress: "",
    avatar_image_path: "",
    location_map_link: "https://www.google.com/search?q=246+N+hyland+avenue+google+maps&client=safari&sca_esv=578022390&rls=en&sxsrf=AM9HkKlskigC5v6wEO2B-hJx2lUvbp5C4w%3A1698721924927&ei=hHBAZZuROJCzptQP38iGyAM&ved=0ahUKEwib46CnqJ-CAxWQmYkEHV-kATkQ4dUDCBA&uact=5&oq=246+N+hyland+avenue+google+maps&gs_lp=Egxnd3Mtd2l6LXNlcnAiHzI0NiBOIGh5bGFuZCBhdmVudWUgZ29vZ2xlIG1hcHMyBRAhGKsCSKgdULoCWIsHcAF4AZABAJgBbaABxwOqAQMzLjK4AQPIAQD4AQHCAgoQABhHGNYEGLADwgIFECEYoAHiAwQYACBBiAYBkAYI&sclient=gws-wiz-serp#",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
